import { defineMessages, useIntl, FormattedMessage } from 'react-intl-next';
import React, { forwardRef, useState } from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield';
import SearchIcon from '@atlaskit/icon/core/search';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';

const i18n = defineMessages({
	hubPreviewDropdownAdminHubGroupRedirect: {
		id: 'editor-main-buttons.hub-preview-as-dropdown.admin-hub-group-redirect',
		defaultMessage: 'View group members in Administration',
		description:
			'Dropdown option label that redirects user to admin hub group page for hub preview as feature',
	},
	hubPreviewDropdownAccessibleToEveryoneOption: {
		id: 'editor-main-buttons.hub-preview-as-dropdown.accessible-to-everyone-option',
		defaultMessage: 'Accessible to anyone',
		description:
			'Dropdown option label that filters content that is accessible to anyone for hub preview as feature',
	},
	hubPreviewDropdownSearchGroups: {
		id: 'editor-main-buttons.hub-preview-as-dropdown.search-groups',
		defaultMessage: 'Search groups',
		description: 'Placeholder for search groups field in dropdown for hub preview as feature',
	},
	hubPreviewDropdownPreviewAs: {
		id: 'editor-main-buttons.hub-preview-as-dropdown.preview-as',
		defaultMessage: 'Preview as',
		description: 'Dropdown button default label for hub preview as feature',
	},
});

const hubPreviewDropdownStyle = xcss({
	maxWidth: '250px',
});
const groupPickerContainerStyles = xcss({
	paddingRight: 'space.150',
	paddingLeft: 'space.150',
	paddingTop: 'space.075',
	paddingBottom: 'space.050',
});

export const HubPreviewAsDropdown = () => {
	const { formatMessage } = useIntl();
	const [hubPreviewSelectedGroup, setHubPreviewSelectedGroup] = useState(
		formatMessage(i18n.hubPreviewDropdownPreviewAs),
	);
	const handleHubPreviewSelectGroup = (name: React.SetStateAction<string>) => {
		setHubPreviewSelectedGroup(name);
	};

	const hubPreviewGroupPicker = forwardRef<HTMLDivElement, React.PropsWithChildren<{}>>(() => (
		<Box xcss={groupPickerContainerStyles}>
			<Textfield
				testId="search-groups"
				placeholder={formatMessage(i18n.hubPreviewDropdownSearchGroups)}
				elemBeforeInput={<SearchIcon label="" spacing="spacious" />}
			/>
		</Box>
	));

	return (
		<Box xcss={hubPreviewDropdownStyle}>
			<DropdownMenu trigger={hubPreviewSelectedGroup} shouldRenderToParent>
				<Box xcss={hubPreviewDropdownStyle}>
					<DropdownItemGroup>
						<DropdownItem component={hubPreviewGroupPicker}>Search group</DropdownItem>
						<DropdownItem
							onClick={() =>
								handleHubPreviewSelectGroup(
									formatMessage(i18n.hubPreviewDropdownAccessibleToEveryoneOption),
								)
							}
						>
							<FormattedMessage {...i18n.hubPreviewDropdownAccessibleToEveryoneOption} />
						</DropdownItem>
					</DropdownItemGroup>
					<DropdownItemGroup hasSeparator>
						<DropdownItem
							href={`${window.location.origin}/admin/groups`}
							elemAfter={<LinkExternalIcon label="" />}
						>
							<FormattedMessage {...i18n.hubPreviewDropdownAdminHubGroupRedirect} />
						</DropdownItem>
					</DropdownItemGroup>
				</Box>
			</DropdownMenu>
		</Box>
	);
};
